<template>
  <el-dialog
    :title="$t('member.title')"
    :visible.sync="visible"
    width="45%"
    @close="closeDialog"
  >
    <el-form ref="form" :model="formData" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.identity')" prop="identity">
            <el-radio-group v-model="formData.identity">
              <el-radio label="党员">{{ $t("member.form.inUse") }}</el-radio>
              <el-radio label="团员">{{ $t("member.form.invalid") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.name')" prop="name">
            <el-input
              v-model="formData.name"
              :placeholder="$t('member.form.namePlaceholder')"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.gender')" prop="isqs">
            <el-radio-group v-model="formData.statusCd">
              <el-radio label="0">{{ $t("member.form.man") }}</el-radio>
              <el-radio label="1">{{ $t("member.form.woman") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.nation')" prop="nation">
            <el-input
              v-model="formData.nation"
              :placeholder="$t('member.form.nationPlaceholder')"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.jiguan')" prop="jiguan">
            <el-input
              v-model="formData.jiguan"
              :placeholder="$t('member.form.jiguanPlaceholder')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.hukou')" prop="hukou">
            <el-input
              v-model="formData.hukou"
              :placeholder="$t('member.form.hukouPlaceholder')"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.birthDate')" prop="birthDate">
            <el-date-picker
              style="width: 100%"
              v-model="formData.birthDate"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('member.form.birthDatePlaceholder')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.number')" prop="number">
            <el-input
              v-model="formData.number"
              :placeholder="$t('member.form.numberPlaceholder')"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.joinDate')" prop="joinDate">
            <el-date-picker
              style="width: 100%"
              v-model="formData.joinDate"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('member.form.joinDatePlaceholder')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.branch')" prop="branch">
            <el-input
              v-model="formData.branch"
              :placeholder="$t('member.form.branchPlaceholder')"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.phone')" prop="phone">
            <el-input
              v-model="formData.phone"
              :placeholder="$t('member.form.phonePlaceholder')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$t('member.form.organization')"
            prop="organization"
          >
            <el-input
              v-model="formData.organization"
              :placeholder="$t('member.form.organizationPlaceholder')"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.address')" prop="address">
            <el-input
              v-model="formData.address"
              :placeholder="$t('member.form.addressPlaceholder')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('member.form.remark')" prop="remark">
            <el-input
              v-model="formData.remark"
              :placeholder="$t('member.form.remarkPlaceholder')"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t("member.cancel") }}</el-button>
      <el-button type="primary" @click="submitForm">{{
        $t("member.submit")
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveRepairSetting } from "@/api/work/repairSettingApi";

export default {
  name: "AddGridWorker",
  data() {
    return {
      visible: false,
      formData: {
        repairTypeName: "",
        repairWay: "200",
        repairSettingType: "200",
        remark: "",
        publicArea: "F",
        payFeeFlag: "F",
        returnVisitFlag: "003",
        isShow: "Y",
        doTime: 24,
        warningTime: 30,
        notifyWay: "WECHAT",
      },
      rules: {
        name: [
          {
            required: true,
            message: this.$t("member.namePlaceholder"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: this.$t("member.form.phonePlaceholder"),
            trigger: "blur",
          },
        ],
        kind: [
          {
            required: true,
            message: this.$t("member.form.kindPlaceholder"),
            trigger: "blur",
          },
        ],
        startTime: [
          {
            required: true,
            message: this.$t("member.form.startTimePlaceholder"),
            trigger: "blur",
          },
        ],
        isfy: [
          {
            required: true,
            message: this.$t("member.form.isfyPlaceholder"),
            trigger: "change",
          },
        ],
        istx: [
          {
            required: true,
            message: this.$t("member.form.istxPlaceholder"),
            trigger: "change",
          },
        ],
        isqs: [
          {
            required: true,
            message: this.$t("member.form.isqsPlaceholder"),
            trigger: "change",
          },
        ],
        isgz: [
          {
            required: true,
            message: this.$t("pet.form.isgzPlaceholder"),
            trigger: "change",
          },
        ],
        isgs: [
          {
            required: true,
            message: this.$t("pet.form.isgsPlaceholder"),
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    open() {
      this.visible = true;
    },

    closeDialog() {
      this.visible = false;
      this.resetForm();
    },

    resetForm() {
      this.$refs.form.resetFields();
      this.formData = {
        repairTypeName: "",
        repairWay: "200",
        repairSettingType: "200",
        remark: "",
        publicArea: "F",
        payFeeFlag: "F",
        returnVisitFlag: "003",
        isShow: "Y",
        doTime: 24,
        warningTime: 30,
        notifyWay: "WECHAT",
      };
    },

    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await saveRepairSetting(this.formData);
            this.$message.success(this.$t("common.operationSuccess"));
            this.$emit("success");
            this.closeDialog();
          } catch (error) {
            console.error("添加报修设置失败:", error);
            this.$message.error(this.$t("repairSetting.addFailed"));
          }
        }
      });
    },
  },
};
</script>
